export const iconFontAwesomeTransportationRocket = (
	<i className="fa-solid fa-rocket"></i>
);
